function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.sth{fill:#1E211E;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "sth",
  d: "M30.3,22h-6.7V13c0-0.6-0.5-1-1-1c-0.6,0-1,0.5-1,1v10.1l0,0.1l0,0l0,0.1l0,0.1l0.1,0.1l0,0l0,0l0,0.1l0,0.1 l0,0c0.2,0.3,0.5,0.5,0.9,0.5h7.8c0.6,0,1-0.5,1-1C31.3,22.4,30.9,22,30.3,22z"
}), /*#__PURE__*/React.createElement("path", {
  className: "sth",
  d: "M33.5,12c-2.9-2.9-6.8-4.5-11-4.5c-4.1,0-8,1.6-11,4.5C8.6,15,7,18.9,7,23c0,4.1,1.6,8,4.5,11 c2.9,2.9,6.8,4.5,11,4.5c4.1,0,8-1.6,11-4.5C36.4,31,38,27.1,38,23C38,18.9,36.4,15,33.5,12z M22.5,36.4c-3.6,0-7-1.4-9.5-3.9 c-2.5-2.5-3.9-5.9-3.9-9.5c0-3.6,1.4-6.9,3.9-9.5c2.5-2.5,5.9-3.9,9.5-3.9c3.6,0,7,1.4,9.5,3.9c2.5,2.5,3.9,5.9,3.9,9.5 c0,3.6-1.4,6.9-3.9,9.5C29.5,35,26.1,36.4,22.5,36.4z"
}));

var SvgHourIcon = function SvgHourIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "46px",
    viewBox: "0 0 45 46",
    style: {
      enableBackground: "new 0 0 45 46"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHourIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hour-icon.40c35298.svg";
export { ForwardRef as ReactComponent };